"use client";

import React, { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="205957" className="flex gap-4">
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <>
      <NavigationMenu className="hidden md:flex" viewport={false}>
        <NavigationMenuList className="gap-8">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative flex flex-col items-center text-[16px] font-default font-medium uppercase tracking-wider text-foreground transition-colors hover:text-primary">
                  <span className="absolute -top-3 h-1 w-4 rounded-full bg-primary opacity-0 transition-all duration-300 group-hover:opacity-100" />
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <div className="md:hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="text-foreground hover:bg-transparent hover:text-primary">
              <Menu className="size-6" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="dark bg-background text-foreground border-l border-border w-[300px] sm:w-[400px]">
            <nav className="flex flex-col gap-8 mt-16 px-4">
              {menuItems.map((item, i) => <div key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="group relative inline-flex flex-col items-start text-lg font-default font-medium uppercase tracking-wider text-foreground transition-colors hover:text-primary">
                    {item.label}
                  </Link>
                </div>)}
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <section id="navigation-header" className={`dark bg-background text-foreground sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-lg border-b border-border shadow-md" : "bg-background border-b border-transparent"}`}>
      <div className="container mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex-shrink-0">
          <Link to="/PropVRaiRedesignPage#">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/propvr_logo.png" className="h-8 w-auto" alt="PropVR.ai" />
          </Link>
        </div>
        
        <MenuProvider menu_id="51">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </section>;
}